import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Handle, Position } from 'reactflow';

import styles from '@components/automations/Automation.module.css';
import Icon from '@components/text/Icon';
import BodyCopy from '@components/typography/BodyCopy';
import { AutomationFragment as AutomationType } from '@typing/Generated';
import { automationTimingBlockDescription } from '@utils/automationUtils';

type AutomationTimingBlock = Extract<AutomationType['blocks'][number], { __typename: 'AutomationTimingBlock' }>;

type Props = {
  data: {
    block: AutomationTimingBlock;
    onSelect: (node: Node) => void;
  };
};

const AutomationTimingBlockNode = ({ data }: Props) => {
  const intl = useIntl();

  const description = useMemo(() => automationTimingBlockDescription(data.block, intl), [data.block, intl]);

  return (
    <div>
      <Handle id="input" isConnectable={false} position={Position.Top} type="target" />
      <IonGrid className="ion-no-padding ion-no-margin">
        <IonRow className={`ion-no-padding ion-no-margin ${styles.blockPrimaryRow}`}>
          <IonCol size="auto">
            <Icon ariaLabelKey="accessibility.ariaLabels.clock" className={styles.nodeIconCol} icon="clock" />
          </IonCol>
          <IonCol>
            <div className={styles.nodeTypeLabel}>
              <FormattedMessage id="models.automation.timingBlock" />
            </div>
            <div>
              <BodyCopy>{description}</BodyCopy>
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
      <Handle id="TIMING" isConnectable={false} position={Position.Bottom} type="source" />
    </div>
  );
};

export default AutomationTimingBlockNode;
